import {observer} from 'mobx-react-lite'
import React, {useCallback} from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId, Hub} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {LinkButtonNew} from '@components/common/base/buttons'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {AddUsersButton} from '@components/common/users-table/add-users-button'
import {UsersTable} from '@components/common/users-table/users-table'
import {MessageBox} from '@components/message-box'
import {
  TwStickerHeader,
  TwStickerHeaderTitle
} from '@components/sticker/sticker-menu/containers'
import {
  useCanInvite,
  useUsersList
} from '@components/sticker/sticker-menu/sticker-menu-user/hooks'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {PageService} from '@extensions/page-service'
import {Sticker} from '@extensions/sticker/sticker'

export interface Props {
  reference: HTMLElement | null
  hub: Hub
}

export const AssignedPopup = observer((props: Props) => {
  const {hub, reference} = props

  const [, store] = useTimelineNewStore()

  const userSticker = Sticker.getUserSticker(hub)
  const listUsers = useUsersList(hub, userSticker)

  const assigned = Sticker.getUsers(hub, userSticker)
  const canInvite = useCanInvite()
  const proj = PageService.getCurrentProject()

  const onToggleSelectedUsers = useCallback(
    (userIds: DataObjectId[]) => {
      if (!hub) {
        return
      }
      const userId = userIds[0]
      if (!PermissionsChecker.checkAssignUser(hub, userId)) {
        MessageBox.warn(Lang.msg.permissionsForbiddenAssignUser)
        return
      }
      Sticker.toggleUser(hub, userId, hub.id)
    },
    [assigned]
  )

  return (
    <Dropdown
      visible
      onVisibleChange={() => store.stopEditing()}
      content={
        <DropdownContent
          className="z-10 min-w-248 !bg-background-primary"
          headerClassName="!bg-background-primary"
          header={
            <TwStickerHeader>
              <TwStickerHeaderTitle data-test="sticker-header-title">
                {Lang.msg.sticker}&nbsp;«{Lang.msg.stickerNames['user']}»
              </TwStickerHeaderTitle>

              <div className="ml-auto">
                <LinkButtonNew
                  onClick={() => {
                    Sticker.unpin(userSticker, hub)
                    store.stopEditing()
                  }}
                >
                  {Lang.msg.unpin}
                </LinkButtonNew>
              </div>
            </TwStickerHeader>
          }
        >
          <div className="min-w-[304px]">
            <div className="sticker-item-list-body">
              <div className="h-[230px]">
                <UsersTable
                  draggableUsers
                  className="h-full"
                  users={listUsers}
                  selected={assigned}
                  onToggled={onToggleSelectedUsers}
                />
              </div>
              {canInvite && (
                <div className="bg-main-old border-solid border-0 border-t border-main-old">
                  <AddUsersButton
                    onClick={() => store.stopEditing()}
                    project={proj}
                  />
                </div>
              )}
            </div>
          </div>
        </DropdownContent>
      }
      reference={reference}
    />
  )
})
